import { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import DashboardTable from 'features/dashboard/table/DashboardTable'
import AdGroupTableHeader from 'features/dashboard/table/adGroup/AdGroupTableHeader'
import { fetchAdGroupTable } from 'features/dashboard/table/adGroup/adGroupTableSlice'
import { DashboardTypes } from 'features/Codes'
import useDebounce from 'utils/hooks/useDebounce'
import useDefaultSort from 'features/dashboard/table/column/useDefaultSort'

const AdGroupTable = () => {
  const dispatch = useDispatch()
  const {
    common: { from, to },
    filter: { filters },
    table: {
      config: {
        columns: { [DashboardTypes.AD_GROUP]: columns },
      },
      campaignTable: { selectedIds: campaignIds },
      adGroupTable: { page, sort },
    },
  } = useSelector(state => state.dashboard, shallowEqual)
  const debouncedColumns = useDebounce(columns, 500)
  useDefaultSort(debouncedColumns)

  useEffect(() => {
    const { abort } = dispatch(fetchAdGroupTable())
    return () => abort()
  }, [dispatch, from, to, page, sort, campaignIds, filters, debouncedColumns])

  return (
    <>
      <div className="set_table">
        <h4 className="screen_out"> 캠페인 탭 내용 </h4>
        <AdGroupTableHeader />
        <DashboardTable />
      </div>
    </>
  )
}
export default AdGroupTable
